<script>
import DeepClone from 'lodash/cloneDeep'
import _baseDropdownPicker from '../_base-dropdown-picker.vue'

export default {
  name: 'TechnicianFromPicker',
  extends: _baseDropdownPicker,
  props: {
    moduleName: {
      type: String,
      default() {
        return this.$constants.CHANGE
      },
    },
  },
  data() {
    this.unassignedValue = null
    return {}
  },
  computed: {
    technicianFromOptions() {
      let options = [
        {
          key: 'changeImplementor',
          text: `${this.$tc('change_implementer')}`,
        },
        {
          key: 'changeManager',
          text: `${this.$tc('change_manager')}`,
        },
        {
          key: 'changeReviewer',
          text: `${this.$tc('change_reviewer')}`,
        },
      ]
      if (this.moduleName === this.$constants.RELEASE) {
        options = [
          {
            key: 'releaseEngineer',
            text: `${this.$tc('release_engineer')}`,
          },
          {
            key: 'releaseManager',
            text: `${this.$tc('release_manager')}`,
          },
          {
            key: 'qaManager',
            text: `${this.$tc('release_qa_manager')}`,
          },
          {
            key: 'releaseReviewer',
            text: `${this.$tc('release_reviewer')}`,
          },
        ]
      }
      return options
    },
    options() {
      return DeepClone(this.technicianFromOptions)
    },
  },
}
</script>
